import update from 'immutability-helper';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep';

update.extend('$deepMerge',(changes,original) => merge(cloneDeep(original),changes));
update.extend('$delete',(changes,original) => omit(cloneDeep(original),changes));

export default update;



// WEBPACK FOOTER //
// ./src/redux/update.js